/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_portalOfficeSchedule_requestCopyPortalOfficeSchedules } from '../models/api_portalOfficeSchedule_requestCopyPortalOfficeSchedules';
import type { api_portalOfficeSchedule_requestGetPortalOfficeSchedule } from '../models/api_portalOfficeSchedule_requestGetPortalOfficeSchedule';
import type { api_portalOfficeSchedule_requestGetPortalOfficeScheduleByPublicRange } from '../models/api_portalOfficeSchedule_requestGetPortalOfficeScheduleByPublicRange';
import type { api_portalOfficeSchedule_requestGetPortalOfficeScheduleEditable } from '../models/api_portalOfficeSchedule_requestGetPortalOfficeScheduleEditable';
import type { api_portalOfficeSchedule_requestSavePortalOfficeSchedules } from '../models/api_portalOfficeSchedule_requestSavePortalOfficeSchedules';
import type { api_portalOfficeSchedule_responseCopyPortalOfficeSchedules } from '../models/api_portalOfficeSchedule_responseCopyPortalOfficeSchedules';
import type { api_portalOfficeSchedule_responseGetPortalOfficeSchedule } from '../models/api_portalOfficeSchedule_responseGetPortalOfficeSchedule';
import type { api_portalOfficeSchedule_responseGetPortalOfficeScheduleByPublicRange } from '../models/api_portalOfficeSchedule_responseGetPortalOfficeScheduleByPublicRange';
import type { api_portalOfficeSchedule_responseGetPortalOfficeScheduleEditable } from '../models/api_portalOfficeSchedule_responseGetPortalOfficeScheduleEditable';
import type { api_portalOfficeSchedule_responseSavePortalOfficeSchedules } from '../models/api_portalOfficeSchedule_responseSavePortalOfficeSchedules';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PortalOfficeScheduleService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * CopyPortalOfficeSchedules
     * 前月のカレンダーのコピー情報を返す(データ更新はしない)
     * @returns api_portalOfficeSchedule_responseCopyPortalOfficeSchedules responseCopyPortalOfficeSchedules
     * @throws ApiError
     */
    public postPortalOfficeScheduleCopy({
        body,
    }: {
        /**
         * requestCopyPortalOfficeSchedules
         */
        body: api_portalOfficeSchedule_requestCopyPortalOfficeSchedules,
    }): CancelablePromise<api_portalOfficeSchedule_responseCopyPortalOfficeSchedules> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_schedule/copy',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get PortalOfficeSchedule
     * Get PortalOfficeSchedule (掲載側用、非公開でも取得可能)
     * @returns api_portalOfficeSchedule_responseGetPortalOfficeSchedule responseGetPortalOfficeSchedule
     * @throws ApiError
     */
    public postPortalOfficeScheduleGet({
        body,
    }: {
        /**
         * requestGetPortalOfficeSchedule
         */
        body: api_portalOfficeSchedule_requestGetPortalOfficeSchedule,
    }): CancelablePromise<api_portalOfficeSchedule_responseGetPortalOfficeSchedule> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_schedule/get',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get PortalOfficeScheduleEditable
     * 編集可能月数分(6ヶ月)分取得する
     * @returns api_portalOfficeSchedule_responseGetPortalOfficeScheduleEditable responseGetPortalOfficeScheduleEditable
     * @throws ApiError
     */
    public postPortalOfficeScheduleGetEditable({
        body,
    }: {
        /**
         * requestGetPortalOfficeScheduleEditable
         */
        body: api_portalOfficeSchedule_requestGetPortalOfficeScheduleEditable,
    }): CancelablePromise<api_portalOfficeSchedule_responseGetPortalOfficeScheduleEditable> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_schedule/get_editable',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get PortalOfficeScheduleByPublicRange
     * Get PortalOfficeSchedule(設定されているpublic_range分取得する)
     * @returns api_portalOfficeSchedule_responseGetPortalOfficeScheduleByPublicRange responseGetPortalOfficeScheduleByPublicRange
     * @throws ApiError
     */
    public postPortalOfficeScheduleGetPublic({
        body,
    }: {
        /**
         * requestGetPortalOfficeScheduleByPublicRange
         */
        body: api_portalOfficeSchedule_requestGetPortalOfficeScheduleByPublicRange,
    }): CancelablePromise<api_portalOfficeSchedule_responseGetPortalOfficeScheduleByPublicRange> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_schedule/get_public',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Save PortalOfficeSchedules
     * 依頼受付スケジュールを更新する
     * @returns api_portalOfficeSchedule_responseSavePortalOfficeSchedules responseSavePortalOfficeSchedules
     * @throws ApiError
     */
    public postPortalOfficeScheduleSave({
        body,
    }: {
        /**
         * requestSavePortalOfficeSchedules
         */
        body: api_portalOfficeSchedule_requestSavePortalOfficeSchedules,
    }): CancelablePromise<api_portalOfficeSchedule_responseSavePortalOfficeSchedules> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/portal_office_schedule/save',
            body: body,
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
